import { Component } from '@angular/core';

@Component({
  selector: 'app-unauthorized',
  templateUrl: 'unauthorized.component.html',
  standalone: true,
})
export class UnauthorizedComponent {}
